<template>
  <a-tabs defaultActiveKey="1">
    <a-tab-pane tab="LIQUIDACIÓN MARCACIONES ABIERTA" key="1">
      <g-master :name="master.endpoint"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :parentData="parentData"
                :modalFieldsSetup="master.modalFieldsSetup"
                @action="masterAction"
                @params="paramsTable"
                modalWidth="90%"
                ref="master"
      >
        <span slot="estadoRenderer" slot-scope="{text}">
          <a-tag :color="text==='LIQ' ? 'blue' : (text === 'CER' ? 'red' : 'red')">{{text}}</a-tag>
        </span>
        <template slot="customButton">
          <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
        </template>
        <template slot="expandedRowRender" slot-scope="{text}">
          <template v-for="ve in master.valoresExpandidos">
            {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
          </template>
        </template>
        <template slot="masterModal" slot-scope="{record}">
          <template>
            <a-row :gutter="[16,16]">
              <a-tabs defaultActiveKey="1">
                <a-tab-pane key="1" v-if="isvisible">
                  <span slot="tab">
                    <a-icon type="vertical-align-top"/>
                    Información General
                  </span>
                  <a-col v-bind="colOptions">
                    <g-lookup :label="$t('Empleado')"
                              :formItemConfig="fiOptions"
                              endpoint="empleados"
                              :decorator="['id_emp', { rules: [{ required: true, message: 'Valor requerido' }] }]">
                    </g-lookup>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Fecha inicio de la marcacion')">
                      <a-date-picker style="width: 100%"
                                     type="date"
                                     valueFormat="Y-MM-DD 00:00:00"
                                     v-decorator="['fecini', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                      ></a-date-picker>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Hora inicio de la marcacion')">
                      <a-input
                        v-decorator="['horaini', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <g-dropdown :label="$t('Tipo de dia de inicio de la marcacion')"
                                :formItemConfig="fiOptions"
                                endpoint="hierarchy_lookup"
                                :decorator="['tipo_dia_ini', { rules: [{ required: false, message: 'Valor requerido'}] }]"
                                :params="tipo_dia_marc">
                    </g-dropdown>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Fecha inicio de la marcacion de descanso')">
                      <a-date-picker style="width: 100%"
                                     type="date"
                                     valueFormat="Y-MM-DD 00:00:00"
                                     v-decorator="['fecinidesc', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                      ></a-date-picker>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Hora inicio de la marcacion de descanso')">
                      <a-input
                        v-decorator="['horainidesc', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Fecha final de la marcacion de descanso')">
                      <a-date-picker style="width: 100%"
                                     type="date"
                                     valueFormat="Y-MM-DD 00:00:00"
                                     v-decorator="['ffindesc', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                      ></a-date-picker>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Hora final de la marcacion de descanso')">
                      <a-input
                        v-decorator="['horafindesc', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Fecha final de la marcacion')">
                      <a-date-picker style="width: 100%"
                                     type="date"
                                     valueFormat="Y-MM-DD 00:00:00"
                                     v-decorator="['ffin', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                      ></a-date-picker>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Hora final de la marcacion')">
                      <a-input
                        v-decorator="['horafin', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <g-dropdown :label="$t('Tipo de dia de fin de la marcacion')"
                                :formItemConfig="fiOptions"
                                endpoint="hierarchy_lookup"
                                :decorator="['tipo_dia_fin', { rules: [{ required: false, message: 'Valor requerido'}] }]"
                                :params="tipo_dia_marc">
                    </g-dropdown>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Año de liquidación')" v-bind="fiOptions">
                      <a-select :default-value="yearToday" v-decorator="['nmyear', { rules: [
                            { required: false},
                           ] }]" style="width: 100%">
                        <a-select-option v-for="year_ in years" :key="year_">
                          {{ year_ }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Mes de liquidación')" v-bind="fiOptions">
                      <a-select v-decorator="['nmmonth', { rules: [
                            { required: false},
                           ] }]" style="width: 100%">
                        <a-select-option v-for="month_ in months_name" :key="month_.value">
                          {{ month_.name }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <g-dropdown :label="$t('Periodo de liquidación')"
                                :formItemConfig="fiOptions"
                                endpoint="hierarchy_lookup"
                                :decorator="['nmperiodo', { rules: [{ required: false, message: 'Valor requerido'}] }]"
                                :params="period_request">
                    </g-dropdown>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <g-dropdown endpoint="hierarchy_lookup"
                                style="width: 100%"
                                :label="$t('Estado')"
                                :formItemConfig="fiOptions"
                                :decorator="['estado', { rules: [{ required: false}] }]"
                                :params="estado_liq_marc">
                    </g-dropdown>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <g-dropdown :label="$t('Origen de la marcacion')"
                                :formItemConfig="fiOptions"
                                endpoint="hierarchy_lookup"
                                :decorator="['origen', { rules: [{ required: false, message: 'Valor requerido'}] }]"
                                :params="origen_marc">
                    </g-dropdown>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <g-dropdown endpoint="hierarchy_lookup"
                                style="width: 100%"
                                :label="$t('Grupo')"
                                :formItemConfig="fiOptions"
                                :decorator="['id_h_att1', { rules: [{ required: false}] }]"
                                :params="grupo"
                                :selectedObj.sync="grupoSeleccionado">
                    </g-dropdown>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <g-dropdown endpoint="hierarchy_lookup"
                                style="width: 100%"
                                :label="$t('Puesto')"
                                :formItemConfig="fiOptions"
                                :decorator="['id_h_att2', { rules: [{ required: false}] }]"
                                :params="puestoParams"
                                :selectedObj.sync="puestoSeleccionado">
                    </g-dropdown>
                  </a-col>
                </a-tab-pane>
                <a-tab-pane key="2">
                  <span slot="tab">
                    <a-icon type="bulb"/>
                    {{$t('Información de horas extras y/o recargos')}}
                  </span>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Total horas de la marcacion')">
                      <a-input
                        v-decorator="['tot_horas_diarias', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Total de las horas del turno en dia normal')">
                      <a-input
                        v-decorator="['total_horas_dia_normal', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Total recargos nocturnos dia normal')">
                      <a-input v-bind="fiOptions" style="width: 100%"
                               v-decorator="['rec_noc', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Total horas extras diurnas')">
                      <a-input v-bind="fiOptions" style="width: 100%"
                               v-decorator="['hextdiur', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Total horas nocturnas')">
                      <a-input v-bind="fiOptions" style="width: 100%"
                               v-decorator="['hextnoct', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Total de horas en dia domingo (sin recargos)')">
                      <a-input v-bind="fiOptions" style="width: 100%"
                               v-decorator="['tot_horas_dom', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Total de horas en dia festivo (sin recargos)')">
                      <a-input-number v-bind="fiOptions" style="width: 100%"
                                      v-decorator="['tot_horas_fest', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Total de recargos nocturnos en dia dominical')">
                      <a-input-number v-bind="fiOptions" style="width: 100%"
                                      v-decorator="['rec_noc_dom', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item
                      :label="$t('Total de recargos nocturnos en dia festivo')">
                      <a-input v-bind="fiOptions" style="width: 100%"
                               v-decorator="['rec_noc_fest', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item
                      :label="$t('Total horas extras Diurnas Festivas')">
                      <a-input v-bind="fiOptions" style="width: 100%"
                               v-decorator="['hextdiur_fest', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item
                      :label="$t('Total Horas extras Nocturnas Festivas')">
                      <a-input v-bind="fiOptions" style="width: 100%"
                               v-decorator="['hextnoct_fest', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                </a-tab-pane>
              </a-tabs>
            </a-row>
          </template>
        </template>
      </g-master>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="DETALLE" key="2">
          <liqmarc-details v-if="id_emp" :id_emp="id_emp" :fecha_ini="fecha_ini_marc"></liqmarc-details>
          <span v-else>Seleccione una registro para ver más.</span>
        </a-tab-pane>
      </a-tabs>
    </a-tab-pane>
    <a-tab-pane tab="LIQUIDACIÓN MARCACIONES CERRADA" key="2">
      <liqmarc-cer></liqmarc-cer>
    </a-tab-pane>
  </a-tabs>
</template>
<script>
  export default {
    data () {
      return {
        isvisible: false,
        registroSeleccionado: {},
        grupoSeleccionado: {},
        puestoSeleccionado: {},
        fileNameExcel: 'marcaciones_a_liquidar',
        paramsT: {},
        endpointExcel: 'liq_marc_/downloadExcel',
        estado_liq_marc: {
          h_lookup_type: 'ESTADO_LIQ_MARCACION',
          use_code: true
        },
        origen_marc: {
          h_lookup_type: 'ORIGEN_MARCACION',
          use_code: true
        },
        period_request: {
          h_lookup_type: 'PERIODOS_LIQUIDACION',
          use_code: true
        },
        tipo_dia_marc: {
          h_lookup_type: 'TIPO_DIA_MARCACION',
          use_code: true
        },
        grupo: {
          h_lookup_type: 'ID_H_ATT1'
        },
        months_name: [
          {name: 'Enero', value: '1'},
          {name: 'Febrero', value: '2'},
          {name: 'Marzo', value: '3'},
          {name: 'Abril', value: '4'},
          {name: 'Mayo', value: '5'},
          {name: 'Junio', value: '6'},
          {name: 'Julio', value: '7'},
          {name: 'Agosto', value: '8'},
          {name: 'Septiembre', value: '9'},
          {name: 'Octubre', value: '10'},
          {name: 'Noviembre', value: '11'},
          {name: 'Diciembre', value: '12'}
        ],
        colOptions: {xs: 24, sm: 6},
        colOptions1: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        yearToday: parseInt(moment().format('YYYY')),
        years: [],
        master: {
          endpoint: 'liq_marc',
          tableSetup: {
            selectedRows: [],
            customSlots: ['estadoRenderer', 'expandedRowRender'],
            tableConfig: {
              rowKey: 'id_liq_marc'
            },
            actions: {
              actions: [
                {
                  name: 'detalles',
                  text: 'Detalles',
                  icon: 'search',
                  props: {size: 'small', type: 'link', icon: 'search', style: 'color:green;'}
                },
                {
                  name: 'masterEdit',
                  text: 'Editar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'edit'}
                }
              ]
            },
            columns: [
              {title: this.$t('ID empleado'), dataIndex: 'id_emp', sorter: true},
              {title: this.$t('Nombre'), dataIndex: 'nombre_empleado', sorter: true},
              {
                title: this.$t('Fecha Inicio Marcacion'),
                dataIndex: 'fecini',
                sorter: true,
                scopedSlots: {filterDropdown: 'dateBetweenFilter'}
              },
              {title: this.$t('Hora Inicio Marcacion'), dataIndex: 'horaini', sorter: true},
              {title: this.$t('Tipo Dia Ini. Marcacion'), dataIndex: 'tipo_dia_inicio_desc', sorter: true},
              {title: this.$t('Fecha Inicio Marcacion Desc.'), dataIndex: 'fecinidesc', sorter: true},
              {title: this.$t('Hora Inicio Marcacion Desc.'), dataIndex: 'horainidesc', sorter: true},
              {title: this.$t('Fecha Final Marcacion Desc.'), dataIndex: 'ffindesc', sorter: true},
              {title: this.$t('Hora Final Marcacion Desc.'), dataIndex: 'horafindesc', sorter: true},
              {
                title: this.$t('Fecha Fin Marcacion'),
                dataIndex: 'ffin',
                sorter: true,
                scopedSlots: {filterDropdown: 'dateBetweenFilter'}
              },
              {title: this.$t('Hora Fin Marcacion'), dataIndex: 'horafin', sorter: true},
              {title: this.$t('Tipo Dia Fin Marcacion'), dataIndex: 'tipo_dia_fin_desc', sorter: true},
              {title: this.$t('Año'), dataIndex: 'nmyear', sorter: true},
              {title: this.$t('Mes'), dataIndex: 'mes_desc', sorter: true},
              {title: this.$t('Periodo'), dataIndex: 'nmperiodo', sorter: true},
              {title: this.$t('Origen Marc.'), dataIndex: 'origen_marc_desc', sorter: true},
              {title: this.$t('Grupo - Puesto'), dataIndex: 'grupo_puesto', sorter: true},
              {title: this.$t('Total Hrs. Marcacion'), dataIndex: 'tot_horas_diarias', sorter: true},
              {title: this.$t('Hrs. Turno Dia Normal'), dataIndex: 'total_horas_dia_normal', sorter: true},
              {title: this.$t('Rec. Nocturno'), dataIndex: 'rec_noc', sorter: true},
              {title: this.$t('Hrs. Extras Diurnas'), dataIndex: 'hextdiur', sorter: true},
              {title: this.$t('Hrs. Exras Nocturnas'), dataIndex: 'hextnoct', sorter: true},
              {title: this.$t('Hrs. Dia Domingo'), dataIndex: 'tot_horas_dom', sorter: true},
              {title: this.$t('Hrs. Dia Festivo'), dataIndex: 'tot_horas_fest', sorter: true},
              {title: this.$t('Rec. Nocturno Dominical'), dataIndex: 'rec_noc_dom', sorter: true},
              {title: this.$t('Rec. Nocturno Festivo'), dataIndex: 'rec_noc_fest', sorter: true},
              {title: this.$t('Hrs. Extras Diurnas Festivas'), dataIndex: 'hextdiur_fest', sorter: true},
              {title: this.$t('Hrs. Extras Nocturnas Festivas'), dataIndex: 'hextnoct_fest', sorter: true},
              {
                title: 'Estado',
                dataIndex: 'estado',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'estadoRenderer'
                }
              },
              {title: 'Creado por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado el', dataIndex: 'created_on', sorter: true},
              {title: 'Modificado por', dataIndex: 'modified_by', sorter: true},
              {title: 'Modificado el', dataIndex: 'modified_on', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'tot_horas_diarias'},
            {name: 'total_horas_dia_normal'},
            {name: 'rec_noc'},
            {name: 'hextdiur'},
            {name: 'hextnoct'},
            {name: 'tot_horas_dom'},
            {name: 'tot_horas_fest'},
            {name: 'rec_noc_dom'},
            {name: 'rec_noc_fest'},
            {name: 'hextdiur_fest'},
            {name: 'hextnoct_fest'}
          ],
          valoresExpandidos: [
            {label: this.$t('Total Hrs. Marcacion'), column: 'tot_horas_diarias'},
            {label: this.$t('Hrs. Turno Dia Normal'), column: 'total_horas_dia_normal'},
            {label: this.$t('Rec. Nocturno'), column: 'rec_noc'},
            {label: this.$t('Hrs. Extras Diurnas'), column: 'hextdiur'},
            {label: this.$t('Hrs. Exras Nocturnas'), column: 'hextnoct'},
            {label: this.$t('Hrs. Dia Domingo'), column: 'tot_horas_dom'},
            {label: this.$t('Hrs. Dia Festivo'), column: 'tot_horas_fest'},
            {label: this.$t('Rec. Nocturno Dominical'), column: 'rec_noc_dom'},
            {label: this.$t('Rec. Nocturno Festivo'), column: 'rec_noc_fest'},
            {label: this.$t('Hrs. Extras Diurnas Festivas'), column: 'hextdiur_fest'},
            {label: this.$t('Hrs. Extras Nocturnas Festivas'), column: 'hextnoct_fest'}
          ]
        }
      }
    },
    computed: {
      parentData () {
        return {liq_marc: true}
      },
      paramsExcel () {
        return {...this.paramsT, ...this.parentData, columns: this.master.tableSetup.columns}
      },
      LiqMarcInfo () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0] : null
      },
      puestoParams () {
        return {
          h_lookup_type: 'ID_H_ATT2',
          id_h_lookup_father: this.grupoSeleccionado.value ? this.grupoSeleccionado.value : this.puestoSeleccionado.value
        }
      },
      id_emp () {
        return this.registroSeleccionado.id_emp
      },
      fecha_ini_marc () {
        return this.registroSeleccionado.fecini
      }
    },
    mounted () {
      this.yearsSelect()
    },
    methods: {
      masterAction (action) {
        switch (action.action) {
          case 'masterCreate':
            this.isvisible = true
            break
          case 'masterEdit':
            this.isvisible = false
            break
          case 'detalles':
            this.registroSeleccionado = action.record
            break
        }
      },
      yearsSelect () {
        for (let i = 2020; i <= (this.yearToday + 6); i++) {
          this.years.push(i)
        }
      },
      paramsTable (params) {
        this.paramsT = params
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/LiqMarc/LiqMarc.vue